import { render } from "./CourseCommentDetail.vue?vue&type=template&id=2de8a1bb&scoped=true"
import script from "./CourseCommentDetail.vue?vue&type=script&lang=ts"
export * from "./CourseCommentDetail.vue?vue&type=script&lang=ts"

import "./CourseCommentDetail.vue?vue&type=style&index=0&id=2de8a1bb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2de8a1bb"

export default script